export const API_GATEWAY_HOSTS = {
    PRODUCTION: 'https://api-gateway.strimix.io/',
    DEVELOPMENT: 'http://localhost:5001/',
}
